import { Button as ButtonBase, Color, Field, linkInline, rem, spacing, themeColor, Typography } from '@unbounded/unbounded-components'
import { Link as RouterLink } from 'react-router-dom'
import styled from 'styled-components'

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${spacing(1)};
  margin-top: ${spacing(1)};
`

export const Actions = styled(Field).attrs({ as: 'div' })`
  display: flex;
  align-items: center;
`

export const Button = styled(ButtonBase)`
  width: ${rem(170)};
`

export const Error = styled.div`
  margin-left: ${spacing()};
  ${Typography.labelMedium};
  color: ${themeColor(Color.danger)};
`

export const Link = styled(RouterLink)`
  ${linkInline};
`
